(function () {
  'use strict';

  var O = window.MMOffers || {};

  function t(en, ar, ctx) {
    if (O.t) return O.t(en, ar, ctx);
    var arL = (ctx && ctx.getAttribute && ctx.getAttribute('data-lang') || document.documentElement.lang || '').indexOf('ar') === 0;
    return arL ? ar : en;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function jp(raw, fallback) {
    return O.jp ? O.jp(raw, fallback) : (function () {
      try { return JSON.parse(raw || '[]'); } catch (e) { return fallback || []; }
    })();
  }

  function configItems(raw) {
    if (O.configItems) return O.configItems(raw);
    var v = jp(raw, []);
    if (Array.isArray(v)) return v;
    if (v && typeof v === 'object') {
      var out = [];
      if (v.trigger) out.push(v.trigger);
      if (v.target) out.push(v.target);
      return out;
    }
    return [];
  }

  function shopRoot() {
    return O.shopRoot ? O.shopRoot() : '/';
  }

  function mmNormVid(id) {
    return String(id == null ? '' : id).split('/').pop();
  }

  if (!window.__mmBogoGuardLoaded) {
    try {
      var s = document.currentScript;
      var base = s && s.src ? s.src.replace(/mm-offers-machine-cart\.js.*$/, '') : '';
      var g = document.createElement('script');
      g.src = base + 'mm-bogo-guard.js';
      g.defer = true;
      document.head.appendChild(g);
    } catch (e) {}
  }

  async function mmCartGuardBundleIntegrity(cartItems) {
    var cartVariantIds = new Set(cartItems.map(function (i) { return mmNormVid(i.variant_id); }));
    var cd;
    try { cd = await (await fetch('/cart.js')).json(); } catch (e) { return; }
    var deals;
    try { deals = JSON.parse((cd.attributes && cd.attributes._flash_deals_data) || '[]'); } catch (e) { return; }
    var broken = new Set();
    deals.filter(function (d) { return d.type === 'bogo' || d.type === 'bogo_trigger'; }).forEach(function (bd) {
      if (!bd.offerId) return;
      if (!cartVariantIds.has(String(bd.variantId))) broken.add(bd.offerId);
    });
    if (!broken.size) return;
    var cleaned = deals.filter(function (d) { return !broken.has(d.offerId); });
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            _flash_deals_data: JSON.stringify(cleaned),
            _mm_country: O.marketCountry ? O.marketCountry() : 'BH'
          }
        }),
      });
    } catch (e) {}
  }

  function offerInCart(offer, items) {
    var oid = String(offer.id);
    return items.some(function (item) {
      var p = item.properties || {};
      if (p._offerId && (String(p._offerId) === oid || String(p._offerId).indexOf(oid) === 0)) return true;
      return false;
    });
  }

  function offerUrl(offer, handle) {
    if (O.offerNavUrl) return O.offerNavUrl(offer, 'cart', handle || firstHandle(offer));
    var root = shopRoot();
    var slug = offer.slug || offer.id;
    if (slug) return root + '/pages/offer?slug=' + slug + '&mm_ref=cart';
    var h = handle || firstHandle(offer);
    if (h) return root + '/products/' + h + '?mm_ref=cart';
    return root + '/pages/bundles?mm_ref=cart';
  }

  function firstHandle(offer) {
    var triggers = jp(offer.triggerProducts);
    if (triggers[0]) return triggers[0];
    var items = configItems(offer.bundleItemsConfig);
    if (items[0] && items[0].handle) return items[0].handle;
    return '';
  }

  async function loadOffers() {
    if (O.loadOffersList) return O.loadOffersList();
    try {
      var url = O.offersApiUrl ? O.offersApiUrl() : '/apps/mm-app/api/offers';
      var res = await fetch(url);
      return res.ok ? res.json() : { offers: [], settings: {} };
    } catch (e) {
      return { offers: [], settings: {} };
    }
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (window.__mmPrefetch && window.__mmPrefetch.fetchProduct) {
      return window.__mmPrefetch.fetchProduct(handle);
    }
    try {
      var r = await fetch(shopRoot() + '/products/' + handle + '.js');
      return r.ok ? r.json() : null;
    } catch (e) {
      return null;
    }
  }

  async function enrichOffer(offer) {
    var handle = firstHandle(offer);
    offer._handle = handle;
    offer._prod = handle ? await fetchProduct(handle) : null;

    if (offer.type === 'BUNDLE' || offer.type === 'BOGO') {
      var items = configItems(offer.bundleItemsConfig);
      offer._bundleProducts = await Promise.all(items.map(function (it) {
        return it && it.handle ? fetchProduct(it.handle) : null;
      }));
    }
    return offer;
  }

  function prodImg(p) {
    if (!p) return '';
    if (typeof p.featured_image === 'string') return p.featured_image;
    if (p.featured_image && p.featured_image.src) return p.featured_image.src;
    return '';
  }

  function cardImage(offer) {
    var imgs = jp(offer.images);
    if (imgs[0]) return imgs[0];
    var items = configItems(offer.bundleItemsConfig);
    for (var i = 0; i < items.length; i++) {
      if (items[i] && items[i].image) return items[i].image;
    }
    return prodImg(offer._prod);
  }

  function priceHtml(offer, ctx) {
    var prices = O.offerPrices ? O.offerPrices(offer, offer._prod, ctx) : { price: 0, compare: 0 };

    if (offer.type === 'BOGO') {
      if (prices.price > 0) {
        var html = '<span class="mm-cs-chip__price mm-cs-chip__price--deal">';
        html += O.priceSpan ? O.priceSpan(prices.price, ctx) : esc(String(prices.price));
        if (prices.compare > prices.price) {
          html += ' <s class="mm-cs-chip__was">' + (O.priceSpan ? O.priceSpan(prices.compare, ctx) : esc(String(prices.compare))) + '</s>';
        }
        html += '</span>';
        return html;
      }
      var bogo = O.bogoLabel ? O.bogoLabel(offer, ctx) : t('Buy 1 Get 1', 'اشتري واحصل على واحد', ctx);
      return '<span class="mm-cs-chip__price mm-cs-chip__price--deal">' + esc(bogo) + '</span>';
    }

    if (offer.type === 'BUNDLE' && prices.price > 0) {
      var bundleHtml = '<span class="mm-cs-chip__price mm-cs-chip__price--deal">';
      bundleHtml += O.priceSpan ? O.priceSpan(prices.price, ctx) : esc(String(prices.price));
      if (prices.compare > prices.price) {
        bundleHtml += ' <s class="mm-cs-chip__was">' + (O.priceSpan ? O.priceSpan(prices.compare, ctx) : esc(String(prices.compare))) + '</s>';
      }
      bundleHtml += '</span>';
      return bundleHtml;
    }

    if (prices.price > 0) {
      var html2 = '<span class="mm-cs-chip__price">';
      html2 += O.priceSpan ? O.priceSpan(prices.price, ctx) : esc(String(prices.price));
      if (prices.compare > prices.price) {
        html2 += ' <s class="mm-cs-chip__was">' + (O.priceSpan ? O.priceSpan(prices.compare, ctx) : esc(String(prices.compare))) + '</s>';
      }
      html2 += '</span>';
      return html2;
    }

    if (offer.type === 'VOLUME') {
      var tiers = jp(offer.volumeTiers);
      var best = 0;
      tiers.forEach(function (tier) {
        var d = parseFloat(tier.discount) || 0;
        if (d > best) best = d;
      });
      if (best > 0) {
        return '<span class="mm-cs-chip__price mm-cs-chip__price--deal">' +
          esc(t('Up to ' + Math.round(best) + '% off', 'خصم حتى ' + Math.round(best) + '%', ctx)) +
        '</span>';
      }
    }

    if (offer.type !== 'BOGO' && offer.type !== 'BUNDLE' && offer.discountValue > 0 && offer.discountType === 'PERCENTAGE') {
      return '<span class="mm-cs-chip__price mm-cs-chip__price--deal">' +
        esc(Math.round(parseFloat(offer.discountValue)) + '% ' + t('off', 'خصم', ctx)) +
      '</span>';
    }

    return '';
  }

  function renderCard(offer, settings, ctx) {
    var title = O.offerTitle ? O.offerTitle(offer, offer._prod, ctx) : (offer.title || '');
    if (title.length > 36) title = title.slice(0, 36) + '…';
    var badge = O.typeLabel ? O.typeLabel(offer.type, ctx) : offer.type;
    var img = cardImage(offer);
    var url = offerUrl(offer, offer._handle);
    var timer = '';
    if (offer.endsAt) {
      timer = '<span class="mm-cs-chip__timer" data-ends-at="' + esc(offer.endsAt) + '"></span>';
    }

    return '<a href="' + esc(url) + '" class="mm-cs-chip mm-cs-chip--' + esc((offer.type || '').toLowerCase()) + '">' +
      (img
        ? '<span class="mm-cs-chip__img"><img src="' + esc(img) + '" alt="" loading="lazy" width="40" height="40"></span>'
        : '<span class="mm-cs-chip__img mm-cs-chip__img--ph" aria-hidden="true"></span>') +
      '<span class="mm-cs-chip__body">' +
        '<span class="mm-cs-chip__row">' +
          '<span class="mm-cs-chip__name">' + esc(title) + '</span>' +
          '<span class="mm-cs-chip__tag">' + esc(badge) + '</span>' +
        '</span>' +
        '<span class="mm-cs-chip__row mm-cs-chip__row--sub">' +
          priceHtml(offer, ctx) +
          timer +
        '</span>' +
      '</span>' +
      '<span class="mm-cs-chip__go" aria-hidden="true">›</span>' +
    '</a>';
  }

  function wireTimers(root) {
    if (!O.startTimer) return;
    var ctx = root.closest('[data-mm-cart-offers]') || root;
    root.querySelectorAll('[data-ends-at]').forEach(function (el) {
      O.startTimer(el.getAttribute('data-ends-at'), el, ctx);
    });
  }

  async function refresh(cart) {
    var wrap = document.querySelector('[data-mm-cart-offers]');
    var track = document.querySelector('[data-mm-cart-offers-track]');
    if (!wrap || !track) return;

    try {
      if (!cart) {
        try { cart = await (await fetch('/cart.js')).json(); } catch (e) { return; }
      }

      var items = cart.items || [];
      if (!items.length) {
        wrap.hidden = true;
        track.innerHTML = '';
        wrap.classList.remove('is-loading');
        return;
      }

      wrap.hidden = false;

      var quickFn;
      var cached = window.__mmPrefetch && window.__mmPrefetch.cache && window.__mmPrefetch.cache.offers;
      if (cached && cached._ok) {
        quickFn = Promise.resolve(cached);
      } else if (O.quickOffersList) {
        quickFn = O.quickOffersList(300);
      } else if (O.loadOffersList) {
        quickFn = O.loadOffersList({ maxWait: 800 });
      } else {
        quickFn = loadOffers();
      }
      var apiRes = await quickFn;
      var settings = apiRes.settings || {};
      var offers = (apiRes.offers || []).filter(function (o) {
        return o && o.type !== 'CART_TIER_GIFT' && !offerInCart(o, items);
      }).slice(0, 5);

      if (!offers.length) {
        wrap.hidden = true;
        track.innerHTML = '';
        wrap.classList.remove('is-loading');
        return;
      }

      track.innerHTML = offers.map(function (o) {
        return renderCard(o, settings, wrap);
      }).join('');
      wireTimers(track);
      wrap.classList.remove('is-loading');
      if (O.hydratePrices) O.hydratePrices(wrap);
      if (O.wireOfferNavigation) O.wireOfferNavigation();

      mmCartGuardBundleIntegrity(items).catch(function () {});

      Promise.all([
        loadOffers(),
        Promise.all(offers.map(enrichOffer))
      ]).then(function (results) {
        if (!document.body.contains(track)) return;
        var fullRes = results[0] || apiRes;
        var fullSettings = fullRes.settings || settings;
        var fullOffers = (fullRes.offers || []).filter(function (o) {
          return o && o.type !== 'CART_TIER_GIFT' && !offerInCart(o, items);
        }).slice(0, 5);
        if (!fullOffers.length) {
          wrap.hidden = true;
          track.innerHTML = '';
          return;
        }
        return Promise.all(fullOffers.map(enrichOffer)).then(function (enrichedFull) {
          if (!document.body.contains(track)) return;
          track.innerHTML = enrichedFull.map(function (o) {
            return renderCard(o, fullSettings, wrap);
          }).join('');
          wireTimers(track);
          if (O.hydratePrices) O.hydratePrices(wrap);
          if (O.wireOfferNavigation) O.wireOfferNavigation();
        });
      }).catch(function () {});
    } catch (err) {
      console.error('[MMCartOffers]', err);
      wrap.hidden = true;
      track.innerHTML = '';
      wrap.classList.remove('is-loading');
    }
  }

  window.MMCartOffers = { refresh: refresh };

  function boot() {
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) refresh(e.detail.cart);
  });
})();
